import { ReactNode } from "react";

import { BoxShadows, Colors } from "~foundations";
import { ValuesOf } from "~utils";

type CardProps = {
  // Required
  children: ReactNode;

  // Optional
  /** Optional click handler */
  onClick?: () => void;
  /** @default false */
  hasNoBorderRadius?: boolean;
  /** @default false */
  borderColor?: ValuesOf<typeof Colors>;
};

/**
 * Atom | Card
 *
 * Cards are containers used to display information. This Card component is
 * shared across all the apps.
 *
 * @Figma https://www.figma.com/design/uJsnuoosxqn26Rot52zCXZ/%F0%9F%A7%B9-Swing-Design-System-v2?node-id=8232-4111&m=dev
 */
export function Card(props: CardProps) {
  const { children, onClick, hasNoBorderRadius, borderColor } = props;

  const Container = onClick ? "button" : "div";

  return (
    <Container
      css={{
        width: "100%",
        backgroundColor: Colors.white200,
        padding: 16,
        borderRadius: hasNoBorderRadius ? undefined : 8,
        transition: "box-shadow 200ms ease",
        boxShadow: onClick ? BoxShadows.interactive : undefined,
        ":hover": {
          boxShadow: onClick ? BoxShadows.hover : undefined,
          cursor: onClick ? "pointer" : undefined,
        },
        border: borderColor ? `1px solid ${borderColor}` : "none",
      }}
      onClick={onClick}
    >
      {children}
    </Container>
  );
}
